<template>
  <Portal :disabled="!isPortalActive">
    <transition name="fade" appear @afterLeave="isPortalActive = false">
      <component
        :is="modalComponent"
        v-if="modalComponent"
        :brand="BrandType"
        :color-logo="colorLogo"
        :color-logo-size="colorLogoSize"
        :customer-type="customerType"
        :discount="discount"
        :promotion="promotion"
      />
    </transition>
  </Portal>
</template>

<script>
import { computed, ref, watch } from '@nuxtjs/composition-api';
import { Portal } from '@linusborg/vue-simple-portal';
import usePartnerPromo from '../hooks/usePartnerPromo';
import { useAbandonmentOverlay } from '@/modules/AbandonmentOverlay';
import { promotionType } from '@/modules/SplashPage/constants/Campaign';

const AbandonmentOverlay = () => import('@/modules/AbandonmentOverlay');
const PartnerOverlay = () => import('./Partners/PartnerOverlay.vue');

export default {
  components: { Portal },
  props: {
    colorLogo: {
      type: String,
      default: '',
    },
    colorLogoSize: {
      type: String,
      default: '',
    },
    discount: {
      type: Number,
      default: 50,
    },
    companyName: {
      type: String,
      default: '',
    },
    customerType: {
      type: String,
      default: '',
    },
    promotion: {
      type: String,
      default: promotionType.SETUP_FEE_DISCOUNT,
    },
  },
  setup() {
    const Abandonment = useAbandonmentOverlay();
    const PartnerPromo = usePartnerPromo();

    const modalComponent = computed(() => {
      if (PartnerPromo.isOverlayVisible.value) {
        return PartnerOverlay;
      }

      if (Abandonment.isOverlayVisible.value) {
        return AbandonmentOverlay;
      }

      return null;
    });

    const BrandType = computed(() => PartnerPromo.overlayType?.value);

    const isPortalActive = ref(!!modalComponent.value);

    watch(modalComponent, (newVal) => {
      if (newVal) {
        isPortalActive.value = true;
      }
    });

    return {
      isPortalActive,
      modalComponent,
      BrandType,
    };
  },
};
</script>
